<template>
  <div>
    <component-graph-editor class="w-full h-48"
                            :transforms-and-source='transformsAndSource'
                            :links='layer.links'
                            :components='layer.components'
                            :transform='{"id":"dummy"}'
                            :component='layer.components[0]' 
                            @added='onAddedComponent'
                            />
  </div>


</template>
<script>
import ComponentGraphEditor from '@edit/organisms/ComponentGraphEditor.vue';
export default {
  props:{
    partutil:{
      type: Object,
      required: true
    },
    transformsAndSource:{
      type: Object,
      required: true
    },
    layer:{
      type:Object,
      required:true
    }
  },
  data() {
    if (!this.layer.components) {
      this.$set(this.layer, 'components', []);
      this.$set(this.layer, 'links', []);
    }
    return {
    }
  },
  components:{
    ComponentGraphEditor
  },
  methods:{
    onAddedComponent({components,links}) {
      console.log('new components,links',components.length,links.length);
      this.$set(this.layer, 'components', components);
      this.$set(this.layer, 'links', links);
    }
  }
}
</script>

